import './Title.css';
import React from 'react';

function Title(props) {
  const stars = () => {
    if (!props.hasOwnProperty('rating') ||
        !props.rating.hasOwnProperty('total') ||
        isNaN(props.rating.total)) return '';

    let stars = [];
    for (let i = 1; i <= 5; i++) {
      (props.rating.total >= i) ?
          stars.push(<span className="ic-star-mini-full" key={i}></span>) :
          stars.push(<span className="ic-star-mini" key={i}></span>);
    }
    return stars;
  };

  const wordFormProducts = props.getWordForm(props.totalProductCount, [props.messages.CATEGORY_PRODUCTS, props.messages.CATEGORY_PRODUCTS_2, props.messages.CATEGORY_PRODUCTS_3]);
  const wordFormReviews = props.getWordForm(props.rating.count, [props.messages.CATEGORY_REVIEWS, props.messages.CATEGORY_REVIEWS_2, props.messages.CATEGORY_REVIEWS_3]);

  return (
      <section id={'title-block'} className="title-section">
        <h1 className="name">{props.title.replace(/&quot;/g, '"')}</h1>
        <span className="count">({props.totalProductCount} {wordFormProducts})</span>
        {
          props.hasOwnProperty('rating') &&
          props.rating.hasOwnProperty('total') &&
          !isNaN(props.rating.total) ?
              <div className="stars">{stars()}</div> :
              <></>
        }
        {
          props.hasOwnProperty('reviews') &&
          props.rating.hasOwnProperty('count') &&
          !isNaN(props.rating.count) ?
              <a className="reviews-link" href={props.reviews.url}>
                <i className="ic-review"></i>
                <span>{props.rating.count} {wordFormReviews}</span>
              </a> :
              <></>
        }
      </section>
  );
}

export default Title;